<template>
    <TreeNode :nodes="nodes" :meta="orgMeta" :parent_id="null"/>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';

import TreeNode from '@/views/history/history-card/components/tree-node.vue';
import { api } from '@/service/http';

defineProps({
    meta: {
        type: Object,
        default: () => {
            return {
                selectionMode: 'single',
            };
        },
    },
});

const nodes = ref([]);

onMounted(async () => {
    console.log(nodes.value);
});

const loadData = async args => {
    try {
        const response = await api(args.url, args.params);
        return response.data;
    } catch (error) {
        console.error('ctx-dog-tree:loadData error:', error.message);
        return {
            result: false,
            error: error.message,
            api: args.url,
            uuid: '552a7862-f5e5-485a-bd8e-850f24aafadc',
        };
    }
};

const loadOrgs = async (parent_id, pattern) => {
    return await loadData({ url: 'core./history/ctx/filials/get', params: { for_dogs: true, pattern } });
};

const loadDogs = async (parent_id, pattern) => {
    const items = await loadData({ url: 'core./history/ctx/dogs/get', params: { dep_id: parent_id, pattern } });
    return items.map(item => ({ ...item, name: `#${item.num} (${item.date})` }));
};


const pntMeta = {
    code: 'pnt',
    load: loadDogs,
    searchTitle: 'Номер точки учета',
    childMeta: null,
    fields: [],
};

const objMeta = {
    code: 'obj',
    load: loadDogs,
    searchTitle: 'Номер энергообъекта',
    childMeta: pntMeta,
    fields: [],
};

const dogMeta = {
    code: 'dog',
    load: loadDogs,
    searchTitle: 'Номер договора',
    childMeta: objMeta,
    fields: [],
};

const orgMeta = {
    code: 'org',
    load: loadOrgs,
    searchTitle: 'Наименование подразделения',
    childMeta: dogMeta,
    fields: [],
};
</script>
